import { Component, OnInit } from '@angular/core';

import { ControllerService } from '../../shared/services/controller.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-rating-finished',
    templateUrl: './rating-finished.component.html',
    styleUrls: ['./rating-finished.component.scss'],
    standalone: false
})
export class RatingFinishedComponent implements OnInit {

  ratings: any = []
  ratingList: any = []

  pbiasesString = ''
  nbiasesString = ''

  pbiases: string[] = []
  nbiases: string[] = []

  abovePage: any = { elements: [] }
  belowPage: any = { elements: [] }

  loaded = false

  baseUrl = environment.audioBaseDir

  bias = ''

  haveThumbnails = false


  modules = []

  progressValue: number = 60

  constructor( public controller: ControllerService) {
  }

  getLabel(label) {
    switch (label) {
      case 'White': return 'White people'
      case 'Black': return 'Black people'
      case 'Asian': return 'South Asian people'
      case 'Lower SES':  return 'people from lower socio-economic groups'
      case 'Higher SES':  return 'people from higher socio-economic groups'
    }
  }

  getString(biases) {
    if (biases.length === 1) {
      return this.getLabel(biases[0]);
    }
    else if (biases.length === 2) {
      return this.getLabel(biases[0]) + " and " + this.getLabel(biases[1]);
    }
    else if (biases.length > 2) {
      return biases.slice(0, biases.length -1).map(this.getLabel).join(', ') + " and " + this.getLabel(biases[biases.length - 1]);
    }
  }

  loadCategory(data, category, threshold) {
    const catData : any = data.find(x => x.category === category);
    if (catData) {
      catData.scores.forEach((cat : any) => {
        if (cat.score > threshold) {
          this.pbiases.push(cat.description)
        }
        else if (cat.score < (-1 * threshold)) {
          this.nbiases.push(cat.description)
        }
      })
    }
  }

  loadBiases(data) {
    this.loadCategory(data, 'Race', 5);
    this.loadCategory(data, 'Socioeconomic status', 2);
    this.pbiasesString = this.getString(this.pbiases)
    this.nbiasesString = this.getString(this.nbiases)
  }

  async getBiasResults() {

    const ratings = await this.controller.getTempData('ratings')
    const biasResults = await this.controller.getBiasResults( ratings )
    this.loaded = true;
    this.loadBiases(biasResults.scores);
    if (this.pbiases.length === 0 && this.nbiases.length === 0) {
      this.bias = 'none';
    }
    else if (this.pbiases.length > 0 && this.nbiases.length > 0) {
      this.bias = 'mixed';
    }
    else if (this.pbiases.length > 0) {
      this.bias = 'positive';
    }
    else {
      this.bias = 'negative';
    }


  }

  async ngOnInit() {

    this.loaded = false;

    const ratings = await this.controller.getTempData('ratings')


    const components = this.controller.getSectionComponents()


    this.abovePage = components[0].subComponents[0]

    if( components[0].subComponents.length == 2 ){
      this.belowPage = components[0].subComponents[1]
    }

    const questions = components[0].elements.filter( ({type}) => type == 'question' )
    const properties = this.controller.getSectionProperties()

    const q1 = questions[0] ? questions[0].value : ''
    const q2 = questions[1] ? questions[1].value : ''


    let haveThumbs = false

    const ratingsObject = ratings.reduce( (acc, it) => {

      // bit of a hack - if the id is 1 digit then this is first question,
      // if id is 2 digits then it's second question.

      if( !acc[it.id] ){
        acc[it.id] = { id: it.id, num : it.id.toString().length }
        acc[it.id]['thumbnail'] = it.thumbnail
        haveThumbs = it.thumbnail != 'false'
      }
      if( it.isVideo ){
        acc[it.id]['video'] = (it.value / 10 ).toFixed(0)
      }
      if( it.isAudio ){
        acc[it.id]['audio'] = (it.value / 10).toFixed(0)
      }
      return acc
    }, { } )

    const mods = Object.entries(ratingsObject).reduce( (acc,[key, ratingObject] : any) => {
      acc[ratingObject.num].ratings.push(ratingObject)
      return acc
    }, { 1: { question: q1, ratings : [] } , 2: {question: q2, ratings: []} })

    this.modules = Object.values( mods ).filter( (module) => module.ratings.length > 0 )

    this.haveThumbnails = haveThumbs

    const showBiasResults = properties && properties.showBias == 'true'
    if( showBiasResults ){
      await this.getBiasResults()

    }
  }

  onComplete(){

    this.controller.gotoNextComponent(false)

  }

}
